<template>


<div class="row" v-if="$gate.isAdmin()">

    <div class="toolbar py-6">
        <div class="container-fluid d-flex align-items-center">
            <div class="page-title d-flex align-items-center flex-wrap me-3 mb-5 mb-lg-0">
                    <span class="h-20px border-gray-200 border-start mx-3"></span>
                    <ol class="breadcrumb breadcrumb-dot text-muted fs-6 fw-semibold">
                        <li class="breadcrumb-item pe-3"><a @click="$router.go(-1)" style="cursor: pointer;" class="pe-3">Înapoi</a></li>
                        <li class="breadcrumb-item pe-3 text-muted">Listă firme</li>
                    </ol>
                    <span class="h-20px border-gray-200 border-start mx-3"></span>
            </div>
        </div>
    </div>
		

    <div class="content d-flex flex-column flex-column-fluid">
        <div class="container-fluid">
            <div class="card card-flush">
                <div class="card-header align-items-center py-5 gap-2 gap-md-5">
                    <div class="card-title">
                        <div class="d-flex align-items-center position-relative my-1">
                            Lista firme
                        </div>
                    </div>
                    <div class="card-toolbar flex-row-fluid justify-content-end gap-5">
                        <div class="input-group w-250px">
                            .
                        </div>
                        <div class="w-100 mw-150px">
                            .
                        </div>
                        <!-- <a class="btn btn-primary" @click="modalAdaugareFirma()">Adaugă firmă</a> -->
                    </div>
                </div>
                <div class="card-body pt-0">
                    <div id="tabel_firme_wrapper" class="dataTables_wrapper dt-bootstrap4 no-footer">
                        <div class="table-responsive w-100">
                          <table class="table table-striped table-row-bordered gy-5 gs-7 w-100" role="grid" id="tabel_firme">
                            <thead>
                              <tr class="text-start text-gray-400 fw-bold fs-7 text-uppercase gs-0">
                                <th class="w-5px pe-2 sorting" rowspan="1" colspan="1" aria-label="" style="width: 10.8906px;"></th>
                                <th class="min-w-10px sorting" tabindex="0" aria-controls="tabel_firme" rowspan="1" colspan="1" aria-label="ID: apasa pentru sortare">ID</th>
                                <th class="min-w-275px sorting" tabindex="0" aria-controls="tabel_firme" rowspan="1" colspan="1" aria-label="Firmă: apasa pentru sortare">Firmă</th>
                                <th class="min-w-125px sorting" tabindex="0" aria-controls="tabel_firme" rowspan="1" colspan="1" aria-label="Abonament: apasa pentru sortare">Abonament</th>
                                <th class="min-w-75px sorting" tabindex="0" aria-controls="tabel_firme" rowspan="1" colspan="1" aria-label="Utilizatori: apasa pentru sortare">Utilizatori</th>
                                <th class="d-none">__search_firme__</th>
                                <th class="min-w-75px sorting" tabindex="0" aria-controls="tabel_firme" rowspan="1" colspan="1" aria-label="Activ: apasa pentru sortare">Activ</th>
                                <th class="min-w-75px sorting" tabindex="0" aria-controls="tabel_firme" rowspan="1" colspan="1" aria-label="Stare: apasa pentru sortare">Stare</th>
                                <th class="text-end min-w-150px sorting" tabindex="0" aria-controls="tabel_firme" rowspan="1" colspan="1" aria-label="Creat / Modificat: apasa pentru sortare">Creat / Modificat</th>
                                <th class="text-end min-w-150px" tabindex="0" rowspan="1" colspan="1" aria-label="Actiuni">Acțiuni</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="f in firme" :key="f.id">
                                <td>
                                  <div class="form-check form-check-sm form-check-custom form-check-solid">
                                    <input class="form-check-input" type="checkbox" :value="f.id">
                                  </div>
                                </td>
                                <td><a class="text-gray-800 text-hover-primary fw-bold">{{ f.id }}</a></td>
                                <td>
                                  <div class="d-flex align-items-center">
                                    <div class="symbol symbol-circle symbol-50px overflow-hidden me-3">
                                      <div v-if="f.sigla" class="symbol-label">
                                        <img :src="`/api/fisiere/sigla-firma/${f.id}`" alt="Logo" style="width: 100%; height: 100%; object-fit: cover;" />
                                      </div>
                                      <div v-else :class="logoClass(f)">{{ (f.denumire || '?').charAt(0) }}</div>
                                    </div>
                                    <div class="ms-5">
                                      <div class="text-dark-75 fw-bold">{{ f.denumire }}</div>
                                      <div class="text-muted small">CUI: {{ f.cui }} <span v-if="f.reg_com">· Reg: {{ f.reg_com }}</span></div>
                                    </div>
                                  </div>
                                </td>
                                <td>
                                  <template v-if="f.abonament && (f.abonament.tip || f.abonament.expira_la)">
                                    <div class="d-flex flex-column">
                                      <span class="badge badge-light-primary align-self-start mb-1" v-if="f.abonament.tip">{{ f.abonament.tip }}</span>
                                      <span class="text-muted small" v-if="f.abonament.expira_la">Expiră: {{ f.abonament.expira_la }}</span>
                                    </div>
                                  </template>
                                  <template v-else>
                                    <span class="text-muted">Fără abonament</span>
                                  </template>
                                </td>
                                <td>
                                  <span class="fw-bold">{{ f.utilizatori_count || 0 }}</span>
                                </td>
                                <td class="d-none">
                                  {{ [f.denumire, f.cui, f.email].filter(Boolean).join(' ') }}
                                </td>
                                <td>
                                  <div class="d-flex flex-column">
                                    <span class="badge me-1" :class="getActivBadge(f.activ).class"> {{ getActivBadge(f.activ).text }} </span>
                                  </div>
                                </td>
                                <td>
                                  <div class="d-flex flex-column">
                                    <span class="badge" :class="getStareFirmaBadge(f.stare_firma).class"> {{ getStareFirmaBadge(f.stare_firma).text }} </span>
                                  </div>
                                </td>
                                <td class="text-end">
                                  <div class="d-flex flex-column align-items-end">
                                    <div>
                                      <span class="text-muted me-2">Creat:</span>
                                      <span class="fw-bold">{{ $filters.formatDate ? $filters.formatDate(f.created_at) : f.created_at }}</span>
                                    </div>
                                    <div>
                                      <span class="text-muted me-2">Modif.:</span>
                                      <span class="fw-bold">{{ f.updated_at ? ($filters.formatDate ? $filters.formatDate(f.updated_at) : f.updated_at) : '-' }}</span>
                                    </div>
                                  </div>
                                </td>
                                <td class="text-end">
                                  <button class="btn btn-sm btn-light-warning" @click="editeazaFirma(f)">
                                    <i class="fas fa-pencil-alt"></i> Editare
                                  </button>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div> 

  <!-- Modal Editare Utilizator REMOVED -->


  <!-- Modal Editare Firmă -->
  <div class="modal fade" id="EditFirmaModal" role="dialog" aria-labelledby="EditFirmaModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-xl modal-dialog-centered modal-custom-width">
      <div class="modal-content">
        <div class="modal-header">
          <h3 class="modal-title" id="EditFirmaModalLabel">Editează firmă</h3>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <form onsubmit="return false;">
            <div class="container-fluid">
              <div class="row">
                <!-- Coloana 1 - Date firmă -->
                <div class="col-md-4">
                  <h5>Date firmă</h5>
                  <hr>
                  <div class="row mb-3">
                    <div class="col-md-6">
                      <label class="form-label">Atribut fiscal</label>
                      <div class="input-group">
                        <span class="input-group-text" id="atrib-fiscal-addon">
                          <i class="ki-duotone ki-badge fs-2"></i>
                        </span>
                        <input type="text" class="form-control" v-model="form.atrib_fiscal" placeholder="Atribut fiscal" aria-describedby="atrib-fiscal-addon" />
                      </div>
                    </div>
                    <div class="col-md-6">
                      <label class="form-label">CUI</label>
                      <div class="input-group">
                        <span class="input-group-text" id="cui-addon">
                          <i class="ki-duotone ki-briefcase fs-2"></i>
                        </span>
                        <input type="text" class="form-control" v-model="form.cui" placeholder="CUI" aria-describedby="cui-addon" />
                        <span class="input-group-text" id="cui-search-addon" style="cursor:pointer"
                          @click="verificaCUI(form.cui)"
                          :class="{ 'bg-primary bg-opacity-10 text-primary': form.cui && form.cui.length > 0 }">
                          <i class="ki-duotone ki-magnifier fs-2"
                            :class="{ 'text-primary': form.cui && form.cui.length > 0 }">
                            <span class="path1"></span>
                            <span class="path2"></span>
                          </i>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="form-floating mb-3">
                    <input type="text" v-model="form.denumire" class="form-control" id="denumire"/>
                    <label for="denumire">Denumire</label>
                  </div>
                  <div class="form-floating mb-3">
                    <input type="text" v-model="form.reg_com" class="form-control" id="reg_com"/>
                    <label for="reg_com">Nr. Reg. Com.</label>
                  </div>
                  <div class="form-floating mb-3">
                    <input type="text" v-model="form.cod_caen" class="form-control" id="cod_caen"/>
                    <label for="cod_caen">Cod CAEN</label>
                  </div>
                  <div class="input-group mb-5">
                    <span class="input-group-text">
                      <i class="ki-duotone ki-bank fs-2"></i>
                    </span>
                    <input type="text" class="form-control" v-model="form.capital_social" placeholder="Capital social">
                    <span class="input-group-text">LEI</span>
                  </div>
                  <div class="form-check form-switch mb-3">
                    <input class="form-check-input" type="checkbox" v-model="form.tva" id="scp_tva">
                    <label class="form-check-label" for="scp_tva">SCP TVA</label>
                  </div>
                  <div class="form-check form-switch mb-3">
                    <input class="form-check-input" type="checkbox" v-model="form.activ" id="activ">
                    <label class="form-check-label" for="activ">Activ</label>
                  </div>
                  <div class="form-floating mb-3">
                    <select class="form-select" id="stare_firma" v-model.number="form.stare_firma">
                      <option :value="0">În așteptare</option>
                      <option :value="1">În verificare</option>
                      <option :value="2">Activă</option>
                      <option :value="10">Dezactivată</option>
                      <option :value="11">Blocat</option>
                    </select>
                    <label for="stare_firma">Stare firmă</label>
                  </div>
                </div>

                <!-- Coloana 2 - Adrese și locație -->
                <div class="col-md-4">
                  <h5>Adrese și locație</h5>
                  <hr>
                  <div class="form-floating mb-3">
                    <input type="text" v-model="form.adresa" class="form-control" id="adresa"/>
                    <label for="adresa">Adresă</label>
                  </div>
                  <div class="form-floating mb-3">
                    <input type="text" v-model="form.strada" class="form-control" id="strada"/>
                    <label for="strada">Stradă</label>
                  </div>
                  <div class="form-floating mb-3">
                    <input type="text" v-model="form.cod_postal" class="form-control" id="cod_postal"/>
                    <label for="cod_postal">Cod poștal</label>
                  </div>
                  <div class="mb-3">
                    <label for="tara" class="form-label">Țara</label>
                    <Select2 id="tara" v-model="form.tara" :options="tari" :settings="setari_select2" @select="incarcaJudete(form.tara)" class="w-100"/>
                  </div>
                  <div class="mb-3">
                    <label for="judet" class="form-label">Județ</label>
                    <Select2 id="judet" v-model="form.judet" :options="judete" :settings="setari_select2" @select="incarcaLocalitati(form.judet)" class="w-100"/>
                  </div>
                  <div class="mb-3">
                    <label for="localitate" class="form-label">Localitate</label>
                    <Select2 id="localitate" v-model="form.localitate" :options="localitati" :settings="setari_select2" class="w-100"/>
                  </div>
                </div>

                <!-- Coloana 3 - Date facturare + Reprezentant legal -->
                <div class="col-md-4">
                  <h5>Date facturare</h5>
                  <hr>
                  <div class="form-floating mb-3">
                    <input type="text" v-model="form.telefon_facturare" class="form-control" id="telefon_facturare"/>
                    <label for="telefon_facturare">Telefon facturare</label>
                  </div>
                  <div class="form-floating mb-3">
                    <input type="text" v-model="form.fax_facturare" class="form-control" id="fax_facturare"/>
                    <label for="fax_facturare">Fax facturare</label>
                  </div>
                  <div class="form-floating mb-3">
                    <input type="email" v-model="form.email" class="form-control" id="email"/>
                    <label for="email">E-Mail</label>
                  </div>
                  <div class="form-floating mb-3">
                    <input type="text" v-model="form.website" class="form-control" id="web"/>
                    <label for="web">Web</label>
                  </div>
                  <div class="form-floating mb-3">
                    <input type="text" v-model="form.telefon" class="form-control" id="telefon2"/>
                    <label for="telefon2">Telefon</label>
                  </div>
                  <div class="form-floating mb-3">
                    <input type="text" v-model="form.fax" class="form-control" id="fax2"/>
                    <label for="fax2">Fax</label>
                  </div>
                  <h5 class="mt-4">Reprezentant legal</h5>
                  <hr>
                  <div class="form-floating mb-3">
                    <input type="text" v-model="form.nume" class="form-control" id="nume"/>
                    <label for="nume">Nume</label>
                  </div>
                  <div class="form-floating mb-3">
                    <input type="text" v-model="form.ci" class="form-control" id="ci"/>
                    <label for="ci">CI</label>
                  </div>
                  <div class="form-floating mb-3">
                    <input type="text" v-model="form.cnp" class="form-control" id="cnp"/>
                    <label for="cnp">CNP</label>
                  </div>
                </div>
              </div>
            </div>
              <div class="col-12">
                <hr class="my-4">
                <div class="row g-5">
                  <div class="col-md-6">
                    <div class="d-flex align-items-center justify-content-between mb-3">
                      <h5 class="mb-0">Conturi bancare</h5>
                      <button type="button" class="btn btn-sm btn-light-primary" @click="adaugContBancar"><i class="fas fa-plus me-1"></i>Adaugă IBAN</button>
                    </div>
                    <div v-if="form.conturi_bancare && form.conturi_bancare.length">
                      <div class="list-group list-group-flush">
                        <div v-for="(c, idx) in form.conturi_bancare" :key="c.__key || idx" class="list-group-item py-3">
                          <div class="row g-3 align-items-center">
                            <div class="col-auto">
                              <div class="form-check form-switch">
                                <input class="form-check-input" type="checkbox" :id="`cb_viz_${idx}`" v-model="c.vizibil">
                                <label class="form-check-label small" :for="`cb_viz_${idx}`">Vizibil</label>
                              </div>
                            </div>
                            <div class="col-6">
                              <div class="form-floating">
                                <input type="text" class="form-control" :id="`iban_${idx}`" v-model="c.iban" placeholder="IBAN" />
                                <label :for="`iban_${idx}`">IBAN</label>
                              </div>
                            </div>
                            <div class="col-4">
                              <div class="form-floating">
                                <input type="text" class="form-control" :id="`banca_${idx}`" v-model="c.banca" placeholder="Bancă" />
                                <label :for="`banca_${idx}`">Bancă</label>
                              </div>
                            </div>
                            <div class="col-1 text-end">
                              <button type="button" class="btn btn-sm btn-icon btn-light-danger" @click="stergeContBancar(idx)"><i class="fas fa-trash"></i></button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-else class="text-muted">Niciun cont bancar.</div>
                  </div>
                  <div class="col-md-6">
                    <div class="d-flex align-items-center justify-content-between mb-3">
                      <h5 class="mb-0">Puncte de lucru</h5>
                      <button type="button" class="btn btn-sm btn-light-primary" @click="adaugPunctLucru"><i class="fas fa-plus me-1"></i>Adaugă punct</button>
                    </div>
                    <div v-if="form.puncte_lucru && form.puncte_lucru.length">
                      <div class="list-group list-group-flush">
                        <div v-for="(p, idx) in form.puncte_lucru" :key="p.__key || idx" class="list-group-item py-3">
                          <div class="row g-3 align-items-center">
                            <div class="col-auto">
                              <div class="form-check form-switch">
                                <input class="form-check-input" type="checkbox" :id="`pl_viz_${idx}`" v-model="p.vizibil">
                                <label class="form-check-label small" :for="`pl_viz_${idx}`">Vizibil</label>
                              </div>
                            </div>
                            <div class="col-6">
                              <div class="form-floating">
                                <input type="text" class="form-control" :id="`pl_denumire_${idx}`" v-model="p.denumire" placeholder="Denumire" />
                                <label :for="`pl_denumire_${idx}`">Denumire</label>
                              </div>
                            </div>
                            <div class="col-4">
                              <div class="form-floating">
                                <input type="text" class="form-control" :id="`pl_adresa_${idx}`" v-model="p.adresa" placeholder="Adresă" />
                                <label :for="`pl_adresa_${idx}`">Adresă</label>
                              </div>
                            </div>
                            <div class="col-1 text-end">
                              <button type="button" class="btn btn-sm btn-icon btn-light-danger" @click="stergePunctLucru(idx)"><i class="fas fa-trash"></i></button>
                            </div>
                          </div>
                          <div class="row g-3 align-items-center mt-1">
                            <div class="col-4">
                              <div class="form-floating">
                                <input type="text" class="form-control" :id="`pl_persoana_${idx}`" v-model="p.persoana_contact" placeholder="Persoana contact" />
                                <label :for="`pl_persoana_${idx}`">Persoana contact</label>
                              </div>
                            </div>
                            <div class="col-4">
                              <div class="form-floating">
                                <input type="text" class="form-control" :id="`pl_tel_${idx}`" v-model="p.telefon_contact" placeholder="Telefon" />
                                <label :for="`pl_tel_${idx}`">Telefon</label>
                              </div>
                            </div>
                            <div class="col-4">
                              <div class="form-floating">
                                <input type="text" class="form-control" :id="`pl_fax_${idx}`" v-model="p.fax" placeholder="Fax" />
                                <label :for="`pl_fax_${idx}`">Fax</label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-else class="text-muted">Niciun punct de lucru.</div>
                  </div>
                </div>
              </div>
          </form>
            <hr class="my-4">
            <div class="mb-4">
              <div class="d-flex align-items-center justify-content-between mb-3">
                <h5 class="mb-0">Siglă firmă</h5>
                <span class="text-muted small">Upload disponibil pentru toți utilizatorii</span>
              </div>
              <div class="d-flex align-items-center gap-4 flex-wrap">
                <div class="symbol symbol-circle symbol-80px overflow-hidden">
                  <div class="symbol-label" v-if="logoPreviewUrl || form.sigla">
                    <img :src="logoPreviewUrl ? logoPreviewUrl : (`/api/fisiere/sigla-firma/${form.id}` + (logoCacheBust ? ('?v='+logoCacheBust) : ''))"
                         alt="Siglă firmă"
                         @error="onLogoImgError"
                         style="width: 100%; height: 100%; object-fit: cover;" />
                  </div>
                  <div v-else :class="logoClass({ id: form.id, denumire: form.denumire })">
                    {{ (form.denumire || '?').charAt(0) }}
                  </div>
                </div>
                <div class="flex-grow-1">
                  <div class="mb-2">
                    <input type="file" accept="image/*" class="form-control" @change="onLogoChange">
                  </div>
                  <div class="d-flex gap-2">
                    <button type="button" class="btn btn-light" @click="resetLogoPreview" :disabled="!logoPreviewUrl">Reset preview</button>
                    <button type="button" class="btn btn-primary" @click="uploadSigla" :disabled="!logoFile || !form.id">Încarcă sigla</button>
                  </div>
                  <div class="form-text mt-2">Formate acceptate: JPG/PNG/WEBP. Imaginea va fi convertită la WEBP.</div>
                </div>
              </div>
            </div>
            <hr class="my-4">
            <div>
              <div class="d-flex align-items-center justify-content-between mb-3">
                <h5 class="mb-0">Utilizatori</h5>
                <span class="text-muted small">{{ edit_utilizatori.length }} înregistrați</span>
              </div>
              <div v-if="edit_utilizatori && edit_utilizatori.length">
                <div class="list-group list-group-flush">
                  <div v-for="u in edit_utilizatori" :key="u.id" class="list-group-item d-flex align-items-center justify-content-between py-3">
                    <div class="d-flex align-items-center gap-3">
                      <div class="symbol symbol-circle symbol-35px bg-light d-flex align-items-center justify-content-center">
                        <i class="fas fa-user"></i>
                      </div>
                      <div class="d-flex flex-column">
                        <span class="fw-bold">{{ u.name }}</span>
                        <span class="text-muted small">{{ u.email }}</span>
                      </div>
                    </div>
                    <span :class="firmRoleBadgeClass(u.drepturi)" class="badge">{{ firmRoleLabel(u.drepturi) }}</span>
                  </div>
                </div>
              </div>
              <div v-else class="text-muted">Niciun utilizator asociat.</div>
            </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Închide</button>
          <button type="button" class="btn btn-success" @click="salveazaFirma">Salvează</button>
        </div>
      </div>
    </div>
  </div>

</div>
</template>


<script>
    
    import moment from "moment";
    //import vue2Dropzone from 'vue2-dropzone'
    //import 'vue2-dropzone/dist/vue2Dropzone.min.css'
    //import VueDatepickerUi from 'vue-datepicker-ui'
    //import 'vue-datepicker-ui/lib/vuedatepickerui.css';
    import { getStareFirmaBadge } from '../../consts/firmaStatus'
    

    
    import Form from 'vform'
    export default {
          components: {
            moment: moment,
          },
    data () {
      return {
        setari_select2: {
          theme: 'bootstrap-5',
          placeholder: 'Selectează din listă',
          width: '100%',
          dropdownParent: null
        },
        tari: [],
        judete: [],
        localitati: [],
        firme: [],
        edit_utilizatori: [],
        editmode: false,
        form: new Form({
          id: '',
          denumire: '',
          cui: '',
          reg_com: '',
          email: '',
          telefon: '',
          telefon_facturare: '',
          fax_facturare: '',
          website: '',
          web: '',
          atrib_fiscal: '',
          nume: '',
          ci: '',
          cnp: '',
          cod_caen: '',
          capital_social: '',
          fax: '',
          tara: '',
          judet: '',
          localitate: '',
          adresa: '',
          strada: '',
          numar: '',
          bloc: '',
          scara: '',
          apartament: '',
          cod_postal: '',
          tva: false,
          activ: true,
          stare_firma: 0,
          conturi_bancare: [],
          puncte_lucru: [],
        }),
        logoFile: null,
        logoPreviewUrl: '',
        logoCacheBust: 0,
      }
    },
    methods: {
      async verificaCUI(cui) {
        if (!cui) {
          toast && toast.fire
            ? toast.fire({
              icon: 'error',
              title: 'Introdu un CUI valid.',
            })
            : console.warn('Introdu un CUI valid.');
          return;
        }

        try {
          const response = await axios.post('/api/efactura/verifica-cui/utilizator', {
            cui,
            force_anaf: this.editmode // Only force fresh ANAF data if we're in edit mode
          });
          const data = response.data || {};

          if (data.status === 'exists' || data.status === 'preview') {
            const firma = data.client || data.firma || {};

            this.form.atrib_fiscal = firma.atrib_fiscal || this.form.atrib_fiscal || 'RO';
            this.form.cui = firma.cui ? String(firma.cui) : '';
            this.form.denumire = firma.denumire || '';
            this.form.reg_com = firma.reg_com || '';

            this.form.adresa = firma.adresa || '';
            this.form.strada = firma.strada || '';
            this.form.cod_postal = firma.cod_postal || '';

            // id-uri pentru Select2
            if (firma.tara) {
              this.form.tara = String(firma.tara);
              this.incarcaTari();              // ca fallback, populăm lista
              this.incarcaJudete(this.form.tara);
            }

            if (firma.judet) {
              this.form.judet = String(firma.judet);
              this.incarcaLocalitati(this.form.judet);
            }

            if (firma.localitate) {
              this.form.localitate = String(firma.localitate);
            }

            this.form.telefon = firma.telefon || '';
            this.form.scp_tva = firma.scp_tva === 1 || firma.scp_tva === true;
            this.form.cod_caen = firma.cod_caen || '';

            if (toast && toast.fire) {
              toast.fire({
                icon: 'success',
                title: data.message || 'Date preluate din ANAF.',
              });
            }
          } else {
            toast && toast.fire
              ? toast.fire({
                icon: 'warning',
                title: 'CUI-ul nu a fost găsit în ANAF.',
              })
              : console.warn('CUI-ul nu a fost găsit în ANAF.');
          }
        } catch (error) {
          console.error(error);
          toast && toast.fire
            ? toast.fire({
              icon: 'error',
              title: 'Eroare la verificarea CUI.',
            })
            : console.error('Eroare la verificarea CUI.');
        }
      },
      getStareFirmaBadge,
      getActivBadge(activ) {
          return {
            class: activ === true ? 'badge-success' : 'badge-danger',
            text: activ === true ? 'Da' : 'Nu'
          }
        },
      logoClass(f) {
        const seedStr = (f && (f.id?.toString() || f.denumire || 'x')).toString();
        let hash = 0; for (let i=0;i<seedStr.length;i++){ hash=((hash<<5)-hash)+seedStr.charCodeAt(i); hash|=0; }
        const palette = ['primary','success','info','warning','danger','dark','secondary'];
        const color = palette[Math.abs(hash)%palette.length];
        return ['symbol-label','fs-3',`bg-light-${color}`,`text-${color}`];
      },
      incarcaTari() {
        axios.get('/api/utils/taris2')
          .then((response) => {
            const arr = Array.isArray(response.data) ? response.data : [];
            this.tari = arr.map(o => ({
              ...o,
              id: (o && o.id != null) ? String(o.id) : (o && o.value != null ? String(o.value) : ''),
            }));
          });
      },
      incarcaJudete(taraId) {
        if (!taraId) { this.judete = []; this.localitati = []; return; }
        axios.get(`/api/utils/judetes2/${taraId}`)
          .then((response) => {
            const arr = Array.isArray(response.data) ? response.data : [];
            this.judete = arr.map(o => ({
              ...o,
              id: (o && o.id != null) ? String(o.id) : (o && o.value != null ? String(o.value) : ''),
            }));
          });
      },
      incarcaLocalitati(judetId) {
        if (!judetId) { this.localitati = []; return; }
        axios.get(`/api/utils/localitatis2/${judetId}`)
          .then((response) => {
            const arr = Array.isArray(response.data) ? response.data : [];
            this.localitati = arr.map(o => ({
              ...o,
              id: (o && o.id != null) ? String(o.id) : (o && o.value != null ? String(o.value) : ''),
            }));
          });
      },
      incarcaFirme() {
        axios.get('/api/administrare/firme')
          .then((response) => {
            this.firme = response.data.firme || response.data || [];
            $(document).ready(function () {
              $('#tabel_firme').DataTable().destroy();
              $('#tabel_firme').DataTable({
                order: [[1, 'desc']],
                dom: 'Bfrtip',
                buttons:['disable'],
                columnDefs: [ { targets: [5], visible: false, searchable: true } ],
                language: { url: 'https://cdn.datatables.net/plug-ins/1.11.3/i18n/ro.json' }
              });
            });
          });
      },
      editeazaFirma(f) {
        this.editmode = true;
        this.form.reset();
        this.form.fill({
          id: f.id,
          sigla: !!f.sigla,
          denumire: f.denumire || '',
          cui: f.cui || '',
          reg_com: f.reg_com || '',
          email: f.email || '',
          telefon: f.telefon || '',
          telefon_facturare: f.telefon_facturare || '',
          fax_facturare: f.fax_facturare || '',
          cod_caen: f.cod_caen || '',
          capital_social: f.capital_social || f.cap_soc || '',
          website: f.website || f.web || '',
          web: f.web || f.website || '',
          fax: f.fax || '',
          atrib_fiscal: f.atrib_fiscal || f.atribut_fiscal || '',
          tara: (f.tara != null && f.tara !== '') ? String(f.tara) : '',
          judet: (f.judet != null && f.judet !== '') ? String(f.judet) : '',
          localitate: (f.localitate != null && f.localitate !== '') ? String(f.localitate) : '',
          adresa: f.adresa || '',
          strada: f.strada || '',
          numar: f.numar || '',
          bloc: f.bloc || '',
          scara: f.scara || '',
          apartament: f.apartament || '',
          cod_postal: f.cod_postal || '',
          tva: !!f.tva,
          activ: !!f.activ,
          stare_firma: Number(f.stare_firma ?? 0),
          nume: f.nume || '',
          ci: f.ci || '',
          cnp: f.cnp || '',
          conturi_bancare: (f.conturi_bancare || []).map(cb => ({ id: cb.id || null, iban: cb.iban || '', banca: cb.banca || '', vizibil: cb.vizibil !== undefined ? !!cb.vizibil : true, __key: `${cb.id || Math.random()}` })),
          puncte_lucru: (f.puncte_lucru || []).map(pl => ({ id: pl.id || null, denumire: pl.denumire || pl.nume || '', adresa: pl.adresa || '', persoana_contact: pl.persoana_contact || '', telefon_contact: pl.telefon_contact || '', fax: pl.fax || '', vizibil: pl.vizibil !== undefined ? !!pl.vizibil : true, __key: `${pl.id || Math.random()}` })),
        });
        // Set dropdown parent to modal for proper z-index
        this.setari_select2 = { ...this.setari_select2, dropdownParent: $('#EditFirmaModal') };
        // Preload cascaded selects
        this.incarcaTari();
        if (this.form.tara) this.incarcaJudete(this.form.tara);
        if (this.form.judet) this.incarcaLocalitati(this.form.judet);
        this.resetLogoPreview();
        this.logoCacheBust = Date.now();
        // încarcă utilizatorii firmei în secțiunea de sub formular
        axios.get(`/api/administrare/firme/${f.id}/utilizatori`).then((res)=>{
          const payload = (res.data && (res.data.utilizatori ?? res.data)) || [];
          const arr = Array.isArray(payload) ? payload : (payload ? [payload] : []);
          this.edit_utilizatori = arr.filter(Boolean);
        }).catch(()=>{ this.edit_utilizatori = []; });
        $('#EditFirmaModal').modal('show');
      },
      adaugContBancar() {
        if (!Array.isArray(this.form.conturi_bancare)) this.form.conturi_bancare = [];
        this.form.conturi_bancare.push({ id: null, iban: '', banca: '', vizibil: true, __key: `new_${Date.now()}_${Math.random()}` });
      },
      stergeContBancar(idx) {
        if (!Array.isArray(this.form.conturi_bancare)) return;
        this.form.conturi_bancare.splice(idx, 1);
      },
      adaugPunctLucru() {
        if (!Array.isArray(this.form.puncte_lucru)) this.form.puncte_lucru = [];
        this.form.puncte_lucru.push({ id: null, denumire: '', adresa: '', persoana_contact: '', telefon_contact: '', fax: '', vizibil: true, __key: `new_${Date.now()}_${Math.random()}` });
      },
      stergePunctLucru(idx) {
        if (!Array.isArray(this.form.puncte_lucru)) return;
        this.form.puncte_lucru.splice(idx, 1);
      },

      salveazaFirma() {
        if (!this.form.id) return;
        // normalizări pentru backend
        this.form.tva = !!this.form.tva;
        this.form.activ = !!this.form.activ;
        this.form.stare_firma = Number(this.form.stare_firma || 0);
        // Cast location IDs back to integer/null for backend validation
        const toIntOrNull = (v) => (v === '' || v === null || v === undefined) ? null : Number(v);
        this.form.tara = toIntOrNull(this.form.tara);
        this.form.judet = toIntOrNull(this.form.judet);
        this.form.localitate = toIntOrNull(this.form.localitate);

        this.$Progress && this.$Progress.start && this.$Progress.start();
        this.form.put(`/api/administrare/firme/${this.form.id}`)
          .then(() => {
            toast.fire({ icon: 'success', title: 'Firmă salvată' });
            $('#EditFirmaModal').modal('hide');
            emitter && emitter.emit && emitter.emit('AfterCreate');
            this.$Progress && this.$Progress.finish && this.$Progress.finish();
          })
          .catch((e) => {
            // Colectăm mesaje din răspunsul backend (Laravel validation)
            let messages = [];
            const resp = e && e.response ? e.response.data : null;
            if (resp) {
              if (typeof resp.message === 'string' && resp.message.trim()) {
                messages.push(resp.message.trim());
              }
              if (resp.errors && typeof resp.errors === 'object') {
                Object.values(resp.errors).forEach((val) => {
                  if (Array.isArray(val)) {
                    val.forEach((m) => { if (m && typeof m === 'string') messages.push(m); });
                  } else if (val && typeof val === 'string') {
                    messages.push(val);
                  }
                });
              }
            } else if (e && e.message) {
              messages.push(e.message);
            }
            // eliminăm duplicatele (insensibil la caz și spații)
            const unique = [];
            const seen = new Set();
            for (const m of messages) {
              if (!m || typeof m !== 'string') continue;
              const key = m.replace(/\s+/g, ' ').trim().toLowerCase();
              if (!key || seen.has(key)) continue;
              seen.add(key);
              unique.push(m.trim());
            }
            const text = unique.length ? unique.slice(0, 5).join('\n') : 'Verifică datele și încearcă din nou.';
            toast.fire({ icon: 'error', title: 'Eroare la salvare', text });
            this.$Progress && this.$Progress.fail && this.$Progress.fail();
          });
      },
      onLogoChange(e) {
        const file = e.target.files && e.target.files[0];
        if (!file) { this.logoFile = null; this.logoPreviewUrl = ''; return; }
        this.logoFile = file;
        // preview local
        const reader = new FileReader();
        reader.onload = (ev) => { this.logoPreviewUrl = ev.target.result; };
        reader.readAsDataURL(file);
      },
      resetLogoPreview() {
        this.logoFile = null;
        this.logoPreviewUrl = '';
      },
      uploadSigla() {
        if (!this.form.id || !this.logoFile) return;
        const fd = new FormData();
        // câmpul se numește 'sigla' în backend-ul existent (adaugaFirmaLogo)
        fd.append('sigla', this.logoFile);
        this.$Progress && this.$Progress.start && this.$Progress.start();
        axios.post(`/api/cont/adaugaFirmaLogo/${this.form.id}`, fd, { headers: { 'Content-Type': 'multipart/form-data' }})
          .then(() => {
            toast.fire({ icon: 'success', title: 'Siglă actualizată' });
            this.form.sigla = true;
            this.logoCacheBust = Date.now(); // forțează refresh la imaginea din storage
            this.resetLogoPreview();
            // opțional: reîncarcă tabela dacă vrei să vezi imediat pictograma nouă în listă
            emitter && emitter.emit && emitter.emit('AfterCreate');
            this.$Progress && this.$Progress.finish && this.$Progress.finish();
          })
          .catch((e) => {
            console.error(e);
            toast.fire({ icon: 'error', title: 'Eroare la upload siglă' });
            this.$Progress && this.$Progress.fail && this.$Progress.fail();
          });
      },
      onLogoImgError() {
        // dacă imaginea nu există / 403, revenim la fallback cu inițială
        this.form.sigla = false;
      },
      stareFirmaLabel(val) {
        switch(Number(val)) {
          case 0: return 'În așteptare';
          case 1: return 'În verificare';
          case 2: return 'Activă';
          case 10: return 'Dezactivată';
          case 11: return 'Blocat';
          default: return 'Necunoscut';
        }
      },
      stareFirmaClass(val) {
        switch(Number(val)) {
          case 0: return 'badge badge-light-warning';
          case 1: return 'badge badge-light-info';
          case 2: return 'badge badge-light-success';
          case 10: return 'badge badge-light-secondary';
          case 11: return 'badge badge-light-danger';
          default: return 'badge badge-light';
        }
      },
      firmRoleLabel(drepturi) {
        const d = Number(drepturi || 0);
        if (d >= 5) return 'Deținător';
        if (d === 4) return 'Administrator';
        if (d === 3) return 'Editor';
        if (d === 2) return 'Operator';
        if (d === 1) return 'Vizualizare';
        return '—';
      },
      firmRoleBadgeClass(drepturi) {
        const d = Number(drepturi || 0);
        if (d >= 5) return 'badge badge-light-success';
        if (d === 4) return 'badge badge-light-danger';
        if (d === 3) return 'badge badge-light-info';
        if (d === 2) return 'badge badge-light-warning';
        if (d === 1) return 'badge badge-light-secondary';
        return 'badge badge-light';
      },
    },
    computed: {
    },

    created(){
      
      this.incarcaFirme();
      emitter.on('AfterCreate', () => { this.incarcaFirme(); });
    },
    
    }
    </script>
    
    
    <style lang="scss" scoped>
    .icon-mare {
        font-size: 24px
    }

    .modal-custom-width {
        max-width: 85% !important;
    }


.badge-role {
  font-size: 1rem;      /* mai mare decât default */
  padding: 0.45rem 0.6rem; /* mai lat și mai înalt */
  line-height: 1;          /* compact */
  border-radius: 0.5rem;   /* colțuri un pic mai rotunjite */
}

    .firme-item {
      transition: background-color .15s ease, box-shadow .15s ease;
    }
    .firme-item:hover {
      background-color: rgba(0,0,0,0.02);
      box-shadow: 0 2px 6px rgba(0,0,0,.06);
    }
    </style>